import Table1, { TableProps as Table1Props } from './Table1/Table';
import Table2, { TableProps as Table2Props } from './Table2/Table';

export type TableProps<Data = never, ColID extends string = string> =
  | ({ version?: '1' } & Table1Props)
  | ({ version: '2' } & Table2Props<Data, ColID>);

function Table<Data = never, ColID extends string = string>(props: TableProps<Data, ColID>) {
  const { version } = props;

  if (version === '2') {
    return <Table2 {...props} />;
  }

  return <Table1 {...props} />;
}

export default Table;
